export const PASSWORD_REGEX = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{6,}$/;

export function validatePassword(password) {
    if (!password || password.length < 6) {
        return "A senha deve ter no mínimo 6 caracteres.";
    }
    if (!PASSWORD_REGEX.test(password)) {
        return "Use letras e números (mínimo 6 caracteres).";
    }
    return null;
}

export function validateEmail(email) {
    const trimmed = String(email || "").trim();
    if (!trimmed) return "Informe seu e-mail.";
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmed)) return "E-mail inválido.";
    return null;
}
